import module from 'app/module.js'

function isBrowserSupported () {
  const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
  const isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor)

  return isSafari || isChrome
}

function logUnsupported () {
  console.groupCollapsed('Browser not supported')
  console.warn('Navigator', navigator.userAgent)
  console.warn('Vendor', navigator.vendor)
  console.groupEnd()
}

module.directive('appEdgemode', () => {
  return {
    restrict: 'A',
    link (scope) {
      if (!isBrowserSupported()) {
        logUnsupported()
        scope.$broadcast('$app:notSupported')
      }
    },
  }
})



// WEBPACK FOOTER //
// ./src/app/directives/app-edgemode/directive.js